const TermsPage = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Splošni pogoji uporabe</h1>

      <p>
        Z uporabo spletne platforme Bazarc se strinjate s spodaj navedenimi pogoji uporabe.
      </p>

      <h3 className="mt-4 mb-3">1. Uporaba platforme</h3>
      <p>
        Platforma je namenjena fizičnim osebam za nakup in prodajo rabljenih izdelkov.
        Vsak uporabnik odgovarja za resničnost in zakonitost svojih objav.
      </p>

      <h3 className="mt-4 mb-3">2. Odgovornost</h3>
      <p>
        Bazarc ne prevzema odgovornosti za vsebino oglasov in ne posreduje pri transakcijah
        med uporabniki.
      </p>

      <h3 className="mt-4 mb-3">3. Kršitve</h3>
      <p>
        Uporabniki, ki kršijo pravila uporabe ali objavljajo neprimerne vsebine, bodo odstranjeni
        s platforme.
      </p>

      <p className="mt-4">Za dodatne informacije nas lahko kontaktirate preko strani <strong>Kontaktirajte nas</strong>.</p>
    </div>
  );
};

export default TermsPage;